import listActions from 'src/modules/documentCategory/list/documentCategoryListActions';
import DocumentCategoryService from 'src/modules/documentCategory/documentCategoryService';
import Errors from 'src/modules/shared/error/errors';
import {i18n} from 'src/i18n';
import {getHistory} from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'DOCUMENT_CATEGORY_DESTROY';

const documentCategoryDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: documentCategoryDestroyActions.DESTROY_STARTED,
      });

      await DocumentCategoryService.destroyAll([id]);

      dispatch({
        type: documentCategoryDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.documentCategory.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/document-category');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: documentCategoryDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: documentCategoryDestroyActions.DESTROY_ALL_STARTED,
      });

      await DocumentCategoryService.destroyAll(ids);

      dispatch({
        type: documentCategoryDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.documentCategory.destroyAll.success'));

      getHistory().push('/document-category');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: documentCategoryDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default documentCategoryDestroyActions;
